module.exports = __webpack_public_path__ + "img/OttoHahn.ba398586.jpg";